import AppState from '../../types/app-state'
import {UserRole} from './state'

export const rolesSelector = (state: AppState): UserRole[] => state.roles.userRoles

export const isFetchingRolesSelector = (state: AppState): boolean => state.roles.isFetching
